import React from 'react'

import ReactJson from '@microlink/react-json-view'
import { CardContent, CardHeader, Grid } from '@mui/material'

const AuditSignalsDetailsView = (row: any) => (
  <Grid container spacing={1} style={{ width: '100%', margin: 0 }}>
    <Grid
      size={{
        sm: 6,
      }}>
      <CardHeader title="Exported signals" />
      <CardContent>
        <ReactJson displayDataTypes={false} src={row.signals} />
      </CardContent>
    </Grid>

    <Grid
      size={{
        sm: 6,
      }}>
      <CardHeader title="Workflow configuration" />
      <CardContent>
        <ReactJson displayDataTypes={false} src={row.workflow} />
      </CardContent>
    </Grid>
  </Grid>
)

export default AuditSignalsDetailsView
